export default __webpack_public_path__ + "static/media/01.9252f78c.jpg";